import "./subHeader.css";
import { NavLink } from "react-router-dom";
import Contact from "../pages/img/subheader/subheader4.jpg";
import i18next from "../config/lang/i18next";

const subHeader = () => (
  <div className="container_header">
    <style>
      {`

  @media (max-width: 700px) {
    .none, .selected {
      width: 33%;
      
    }
  }
`}
    </style>
    <div
      className="sub_header"
      style={{ backgroundImage: `url(${Contact})`, backgroundSize:"cover" }}
    >
      <div className="sub_header_txt">
        <h2>Customer Center</h2>
        <hr></hr>
        <h3>Welcome to GM Medical Customer Center</h3>
      </div>

      <div className="ul_wrapper fixed">
        <ul className="menu_container clearfix">
          <NavLink
            exact="true"
            onClick={() => window.location.href("/inquiry")}
            className={(navData) => (navData.isActive ? "selected" : "none")}
            to="/inquiry"
          >
            <li>{i18next.t("navbar.4-1")}</li>
          </NavLink>
       
          <NavLink
            exact="true"
            className={(navData) => (navData.isActive ? "selected" : "none")}
            to="/career"
          >
            <li>{i18next.t("navbar.4-2")}</li>
          </NavLink>
        </ul>
      </div>
    </div>
  </div>
);

export default subHeader;
